import { Component, computed, input, OnInit, signal } from '@angular/core';
import { AppModule } from "../../app.module";
import { PricingService } from '../pricing.service';
import { StockCustomItem, StockItem } from '../../models/stock';
import { FormControl, FormGroup } from '@angular/forms';
import { NotificationService } from '../../shared/notification.service';
import { SharedDataService } from '../../shared/shareddata.service';

@Component({
  selector: 'app-manual-add-stock-item',
  imports: [AppModule],
  templateUrl: './manual-add-stock-item.html',
  styleUrl: './manual-add-stock-item.less'
})
export class ManualAddStockItem implements OnInit {
  availableStockItems = signal<StockItem[]>([]); 
  selectedBrandId = signal<number | null>(null);
  selectedSize = signal<string | null>(null);
  selectedStockItem = signal<StockItem | null>(null);

  stockForm = new FormGroup({
    stockCode: new FormControl(''),
    cost: new FormControl(0)
  })

  stockCustomForm = new FormGroup({
    description: new FormControl(''),
    stockCode: new FormControl(''),
    cost: new FormControl(0)
  })

  public filteredStockItems = computed(() => {
    const stockItems = this.availableStockItems();
    const selectedSize = this.selectedSize();

    let items = stockItems;
    
    if (this.selectedBrandId() !== null) {
      items = items.filter(item => item.tyreBrandId === this.selectedBrandId());
    }

      if (selectedSize !== null) {
      items = items.filter(item => selectedSize.includes(item.genCode.toString()));
    }
    return items;
    
  })

  public brandNames = computed(() => {
    const brands = this.sharedData.tyreBrands;
    return brands.map(brand => ({ value: brand.tyreBrandId, text: brand.brandName })).sort((a, b) => a.text.localeCompare(b.text));
  })

  public sizeOptions = computed(() => {
    const sizes = this.sharedData.tyreSizes;
    return sizes.map(size => ({ value: size.gencode.toString(), text: size.size })).sort((a, b) => a.text.localeCompare(b.text));

  })

  constructor(private pricingService: PricingService, private notificationService: NotificationService, private sharedData: SharedDataService) { }

  ngOnInit(): void {
    this.loadAvailableStockItems();
  }

  private loadAvailableStockItems() {
    this.pricingService.getNMSFStockList().subscribe({
      next: (data : StockItem[]) => {
        this.availableStockItems.set(data);
        console.log('Available stock items loaded:', this.filteredStockItems());
      },
      error: (err) => {
        this.notificationService.handleError(err, 'Error loading available stock items.');
      }
    });
  }

  public addStockItem() {

    if (this.stockForm.invalid || !this.selectedStockItem()) {
      this.notificationService.showError('Please fill in all required fields and select a stock item.');
      return;
    }
    const newItem = new StockItem();
    newItem.msfId = this.selectedStockItem()?.msfId!;
    newItem.soh = 0;
    newItem.cost = this.stockForm.value.cost!;
    newItem.description = this.selectedStockItem()?.description!;
    newItem.stockCode = this.stockForm.value.stockCode!;

    this.pricingService.addNewStockItem(newItem).subscribe({
      next: (data: StockItem) => {
        this.notificationService.showSuccess('Stock item added successfully.');
        this.stockForm.reset();
        this.selectedBrandId.set(null);
        this.selectedSize.set(null);
        this.selectedStockItem.set(null);
      },
      error: (err) => {
        this.notificationService.handleError(err, 'Error adding new stock item.');
      }
    });
  }

  public addCustomStockItem() {
    if (this.stockCustomForm.invalid) {
      this.notificationService.showError('Please fill in all required fields.');
      return;
    }
    const newItem = new StockCustomItem();
    newItem.soh = 0;
    newItem.cost = this.stockCustomForm.value.cost!;
    newItem.description = this.stockCustomForm.value.description!;
    newItem.stockCode = this.stockCustomForm.value.stockCode!;

  this.pricingService.addNewCustomStockItem(newItem).subscribe({
    next: (data: StockCustomItem) => {
      this.notificationService.showSuccess('Custom stock item added successfully.');
      this.stockCustomForm.reset();
    },
    error: (err) => {
      this.notificationService.handleError(err, 'Error adding new custom stock item.');
    }
  });
}
}
